module.exports = __webpack_public_path__ + "static/media/music.1f981fff.wav";